import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { SearchRounded } from '@mui/icons-material';

type ActionResponse = { id: string }[];

type ActionArgs = {
    postIds: string[];
};

export type AndieGetPostsByIdProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieGetPostsById = (props: AndieGetPostsByIdProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={(args) => t('andie.tool.get-posts-by-id.title', { value: args?.postIds?.length ?? 0 })}
            icon={<SearchRounded fontSize="small" />}
            loadingMessages={(args) => [
                t('andie.tool.get-posts-by-id.loading', { value: args?.postIds?.length ?? 0 }),
            ]}
            completeMessage={({ result }) =>
                t('andie.tool.get-posts-by-id.complete', {
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieGetPostsById;
